<template>
  <div class='EnbLogin01' ref="login">
    <enb-label text="Login" config="font-weight: bold"/>
    <enb-label text="Informe suas credenciais abaixo" config="font-size: 12px"/>
    <enb-input v-model:email="email" @update:modelValue="newValue => email = newValue" :options="{ label: 'Email', styleLabel: { fontSize: '12px' } }"/>
    <enb-input v-model:email="senha" @update:modelValue="newValue => senha = newValue" :options="{ type: 'password', label: 'Senha', styleLabel: { fontSize: '12px' } }"/>
    <enb-button @click="login" text="Entrar" :options="{ style: { fontSize: '12px' } }"/>
    <div class="pw-recovery" @click="$router.push('/pwrecovery')">Esqueci a senha</div>
    <div class="msg" v-if="msg.length > 0">{{ msg }}</div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import EnbLabel from '@/components/EnbLabel.vue'
import EnbInput from '@/components/EnbInput.vue'
import EnbButton from '@/components/EnbButton.vue'
export default {
  name: 'EnbLogin01',
  components: { EnbLabel, EnbInput, EnbButton },
  data () {
    return {
      email: '',
      senha: '',
      msg: ''
    }
  },
  methods: {
    ...mapActions(['GetLogin', 'SetModal01']),
    login () {
      this.GetLogin({ login: this.email, senha: this.senha })
        .then(res => {
          if(res.user !== null) {
            this.SetModal01({ active: false })
              .then(() => {
                if(this.$route.path !== '/complete')
                this.$router.push('/profile')
                if(res.user.tipo === 'a') {
                  this.$router.push('/painel')
                  if(!res.user.logincount) {
                    this.$router.push('/painel/preference')
                  }
                }
              })
          }
          else {
            if(res.code !== null && res.code === 537) {
              window.location.replace('https://enegocios.online/atualizar-sistema/')
              return
            }
            this.msg = res.message
          }
        })
    }
  },
  mounted () {
    this.$refs.login.addEventListener('keydown', (e) => {
      if(e.key === 'Enter') {
        e.preventDefault()
        this.login()
      }
    })
  }
}
</script>

<style scoped>
.EnbLogin01 {
  width: 350px;
  padding: 2%;
  position: absolute;
  margin: auto;
  background-color: #FFFFFF;
  border-radius: 5px;
}

.msg {
  padding: 2%;
  border: thin solid #CCCCCC;
  border-radius: 5px;
  margin-top: 3%;
  background-color: #EEEEEE;
  color: Red;
}

.pw-recovery {
  width: max-content;
  margin: auto;
  cursor: pointer;
  padding-top: 4%;
  font-size: 12px;
}
</style>
